import { numberShareApi } from '@/helpers/apis';
import axios from '@/helpers/axios';

export const getNumberShareDetails = () => {
  const url = numberShareApi.NUMBER_SHARE;
  return axios.get(url);
};

export const getServiceNumberShare = () => {
  const url = numberShareApi.SERVICE_NUMBER_SHARE;
  return axios.get(url);
};

export const getNumberShareEligibility = (request) => {
  const url = numberShareApi.NUMBER_SHARE_ELIGIBILITY;
  return axios.post(url, request);
};
